const CampaignId = "campaignId";
const CampaignContents = "campaignContents";
const CampaignCautions = "campaignCautions";
const ImageContents = "imageContents";
const Prize = "prize";
const CampaignState = "state";
const SharedLine = "sharedLine";
const IsJoinShare = "isJoinShare";
const IsRetry = "isRetry";
const TimerId = "timerId";
const LinkShare = "linkShare";
const isShared = "isShared";
const IsShareable = "isShareable";
const CodeVerifier = "codeVerifier";

export function getLinkShare() {
  return localStorage.getItem(LinkShare);
}

export function setLinkShare(link) {
  return localStorage.setItem(LinkShare, link);
}

export function removeLinkShare() {
  return localStorage.removeItem(LinkShare);
}

export function getTimerId() {
  return localStorage.getItem(TimerId);
}

export function setTimerId(timerId) {
  return localStorage.setItem(TimerId, timerId);
}

export function removeTimerId() {
  return localStorage.removeItem(TimerId);
}

export function getIsRetry() {
  return localStorage.getItem(IsRetry);
}

export function setIsRetry(isRetry) {
  return localStorage.setItem(IsRetry, isRetry);
}

export function removeIsRetry() {
  return localStorage.removeItem(IsRetry);
}

export function getSharedLine() {
  return localStorage.getItem(SharedLine);
}

export function setSharedLine(shareLine) {
  return localStorage.setItem(SharedLine, shareLine);
}

export function removeSharedLine() {
  return localStorage.removeItem(SharedLine);
}

export function getIsJoinShare() {
  return localStorage.getItem(IsJoinShare);
}

export function setIsJoinShare(join) {
  return localStorage.setItem(IsJoinShare, join);
}

export function removeIsJoinShare() {
  return localStorage.removeItem(IsJoinShare);
}

export function getIsShareable () {
  return localStorage.getItem(IsShareable);
}

export function setIsShareable(isShareable) {
  return localStorage.setItem(IsShareable, isShareable);
}

export function removeIsShareable() {
  return localStorage.removeItem(IsShareable);
}

export function getCampaignId() {
  return localStorage.getItem(CampaignId);
}

export function setCampaignId(campaignId) {
  return localStorage.setItem(CampaignId, campaignId);
}

export function removeCampaignId() {
  return localStorage.removeItem(CampaignId);
}

export function getCampaignContents() {
  return localStorage.getItem(CampaignContents) ? JSON.parse(localStorage.getItem(CampaignContents)) : null;
}

export function setCampaignContents(response) {
  return localStorage.setItem(CampaignContents, JSON.stringify(response));
}

export function removeCampaignContents() {
  return localStorage.removeItem(CampaignContents);
}

export function getCampaignCautions() {
  return localStorage.getItem(CampaignCautions);
}

export function setCampaignCautions(response) {
  return localStorage.setItem(CampaignCautions, response);
}

export function removeCampaignCautions() {
  return localStorage.removeItem(CampaignCautions);
}

export function getCampaignImageContents() {
  return localStorage.getItem(ImageContents) ? JSON.parse(localStorage.getItem(ImageContents)) : null;
}

export function setCampaignImageContents(response) {
  return localStorage.setItem(ImageContents, JSON.stringify(response));
}

export function removeCampaignImageContents() {
  return localStorage.removeItem(ImageContents);
}

export function getPrize() {
  return localStorage.getItem(Prize) ? JSON.parse(localStorage.getItem(Prize)) : null;
}

export function setPrize(response) {
  return localStorage.setItem(Prize, JSON.stringify(response));
}

export function removePrize() {
  return localStorage.removeItem(Prize);
}

export function getState() {
  return localStorage.getItem(CampaignState);
}

export function setState(state) {
  return localStorage.setItem(CampaignState, state);
}

export function removeState() {
  return localStorage.removeItem(CampaignState);
}

export function getIsShared() {
  return localStorage.getItem(isShared);
}

export function setIsShared(isShare) {
  return localStorage.setItem(isShared, isShare);
}

export function removeIsShared() {
  return localStorage.removeItem(isShared);
}

export function getCodeVerifier() {
  return localStorage.getItem(CodeVerifier)? JSON.parse(localStorage.getItem(CodeVerifier)) : null;
}

export function setCodeVerifier(codeVerifier) {
  return localStorage.setItem(CodeVerifier, JSON.stringify(codeVerifier));
}

export function removeCodeVerifier() {
  return localStorage.removeItem(CodeVerifier);
}

export function removeAllCampaignCookie() {
  if (getLinkShare()) {
    removeLinkShare();
  }
  if (getTimerId()) {
    removeTimerId();
  }
  if (getIsRetry()) {
    removeIsRetry();
  }
  if (getSharedLine()) {
    removeSharedLine();
  }
  if (getIsJoinShare()) {
    removeIsJoinShare();
  }
  if (getIsShareable()) {
    removeIsShareable();
  }
  if (getCampaignId()) {
    removeCampaignId();
  }
  if (getCampaignContents()) {
    removeCampaignContents();
  }
  if (getCampaignCautions()) {
    removeCampaignCautions();
  }
  if (getCampaignImageContents()) {
    removeCampaignImageContents();
  }
  if (getPrize()) {
    removePrize();
  }
  if (getState()) {
    removeState();
  }
  if (getIsShared()) {
    removeIsShared();
  }
  if (getCodeVerifier()) {
    removeCodeVerifier();
  }
}